import { render } from "./CxRecovery.vue?vue&type=template&id=08fc097c&ts=true"
import script from "./CxRecovery.vue?vue&type=script&lang=ts"
export * from "./CxRecovery.vue?vue&type=script&lang=ts"

import "./CxRecovery.vue?vue&type=style&index=0&id=08fc097c&lang=less"

import exportComponent from "C:\\hexagon_develop\\hexagon_develop\\conx-ui\\microfrontends\\conx-ui-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__